module.exports = __webpack_public_path__ + "img/hts_edelstahl.429f6156.jpg";